/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionFromJSONTyped,
    PaxCheckPaxSessionToJSON,
    PaxCheckPaxSessionToJSONTyped,
} from './PaxCheckPaxSession';

/**
 * 
 * @export
 * @interface PaxCheckSetAnswersResponse
 */
export interface PaxCheckSetAnswersResponse {
    /**
     * 
     * @type {PaxCheckPaxSession}
     * @memberof PaxCheckSetAnswersResponse
     */
    data?: PaxCheckPaxSession;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckSetAnswersResponse
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckSetAnswersResponse interface.
 */
export function instanceOfPaxCheckSetAnswersResponse(value: object): value is PaxCheckSetAnswersResponse {
    return true;
}

export function PaxCheckSetAnswersResponseFromJSON(json: any): PaxCheckSetAnswersResponse {
    return PaxCheckSetAnswersResponseFromJSONTyped(json, false);
}

export function PaxCheckSetAnswersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckSetAnswersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckPaxSessionFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckSetAnswersResponseToJSON(json: any): PaxCheckSetAnswersResponse {
    return PaxCheckSetAnswersResponseToJSONTyped(json, false);
}

export function PaxCheckSetAnswersResponseToJSONTyped(value?: PaxCheckSetAnswersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckPaxSessionToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

